module.exports = __webpack_public_path__ + "static/img/twn.9f8ff4bf.png";